import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="qr-download"
export default class extends Controller {
  static targets = ["qr"];

  download() {
    const svgElement = this.qrTarget.querySelector("svg");
    const name = this.element.querySelector("[data-name]")?.innerText || "";
    const district =
      this.element.querySelector("[data-district]")?.innerText || "";

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);

    const svgBlob = new Blob([svgString], {
      type: "image/svg+xml;charset=utf-8",
    });

    const url = URL.createObjectURL(svgBlob);
    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement("canvas");

      const width = 600;
      const height = 750;
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");

      ctx.fillStyle = "#f9fafb";
      ctx.fillRect(0, 0, width, height);

      // Card
      const cardWidth = 520;
      const cardHeight = 650;
      const cardX = (width - cardWidth) / 2;
      const cardY = 40;
      const radius = 24;

      ctx.fillStyle = "#ffffff";
      roundRect(ctx, cardX, cardY, cardWidth, cardHeight, radius);
      ctx.fill();

      // QR
      const qrSize = 400;
      const qrX = (width - qrSize) / 2;
      const qrY = cardY + 40;
      ctx.drawImage(img, qrX, qrY, qrSize, qrSize);

      // Name
      ctx.fillStyle = "#111827";
      ctx.font = "bold 28px Inter, Arial";
      ctx.textAlign = "center";
      ctx.fillText(name, width / 2, qrY + qrSize + 60);

      // District
      ctx.fillStyle = "#6b7280";
      ctx.font = "20px Inter, Arial";
      ctx.fillText(district.toUpperCase(), width / 2, qrY + qrSize + 100);

      URL.revokeObjectURL(url);

      const pngUrl = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = "qr_code.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    img.src = url;
  }
}

// Rounded rectangle
function roundRect(ctx, x, y, width, height, radius) {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
}
